import { connect } from 'react-redux';
import cx from 'classnames';
import { createStructuredSelector } from 'reselect';
import { debounce } from 'lodash';
import { UPLOAD_SOURCES } from '@cld/upload-widget-common';
import TabHeader from 'root/components/TabHeader';
import t from 'common/i18n';
import consts from '../../data/consts';
import { selectMediaType, selectSearchTermText, selectUserName, selectSelectedItems, selectFiltersPanelOpen, selectFiltersChanged } from '../../selectors';
import bindActions, { types as ats } from '../../actions';
import TabHeaderButtons from '../../../common/components/TabHeaderButtons';

const MEDIA_TYPES_VALUES = Object.values(consts.MEDIA_TYPES);

const { SHUTTERSTOCK } = UPLOAD_SOURCES;

export const Header = (props) => {
  const { actions, showSearch } = props;

  const onSearch = () => {
    props.doSearch({ searchTerm: props.searchTermText });
  };

  const onSearchTermChange = debounce(
    (term) => {
      actions[ats.SET_SEARCH_TERM_TEXT]({ term });
    },
    50,
    { leading: true }
  );

  const onMediaTypeChange = (option) => {
    props.doSearch({ mediaType: option.value });
  };

  const mediaTypes = MEDIA_TYPES_VALUES.map((value) => ({
    label: t(`shutterstock.media_types.${value}`),
    value,
  }));

  const selectedMediaType = showSearch ? (mediaTypes.find((type) => type.value === props.mediaType) || {}).label : null;

  const title = props.isInPurchase && props.selectedItems.length ? props.selectedItems[0].subtitle : null;

  return (
    <TabHeader
      source={UPLOAD_SOURCES.SHUTTERSTOCK}
      showSearch={showSearch}
      expandSearch
      hideBackButton
      searchTerm={props.searchTermText}
      searchTermHandler={onSearchTermChange}
      clearBtnTip={t('shutterstock.search.reset')}
      showClearButton={props.hasSearchTerm}
      onClearClickHandler={props.clearSearchTerm}
      searchClickHandler={onSearch}
      searchOptions={mediaTypes}
      selectedSearchOption={selectedMediaType}
      searchOptionHandler={onMediaTypeChange}
      userName={props.userName}
      onLogout={props.onLogout}
      onBackNavigation={props.onBackNavigation}
      searchInputPlaceholder={t('shutterstock.search.placeholder')}
      showBackButton={props.isInPurchase}
      titleCenter={title}
    >
      {showSearch && (
        <div className={cx('flex justify-content-between', 'h-100')}>
          <TabHeaderButtons
            id={SHUTTERSTOCK}
            routes={consts.ROUTES}
            searchTerm={props.searchTermText}
            clearSearchTerm={() => props.clearSearchTerm()}
            isFiltersPanelOpen={props.isFiltersPanelOpen}
            showIndicator={!props.isFiltersPanelOpen && props.didFiltersChange}
            toggleFilterPanel={() => actions[ats.TOGGLE_FILTERS_PANEL]()}
          />
        </div>
      )}
    </TabHeader>
  );
};

export default connect(
  createStructuredSelector({
    userName: selectUserName,
    mediaType: selectMediaType,
    searchTermText: selectSearchTermText,
    selectedItems: selectSelectedItems,
    isFiltersPanelOpen: selectFiltersPanelOpen,
    didFiltersChange: selectFiltersChanged,
  }),
  (dispatch) => ({
    actions: bindActions(dispatch),
  })
)(Header);
